import { Navigator }   from "../../main_components/navigator";
import Styles          from "./view_project.module.css";
import { Project }     from "./view_project_components";
import { ProHeadline } from "../../subcomponents/subcomponents";
import testImg         from "../../images/test2.jpg"
export const ViewProjectBody = ( props ) => {
    const {  } = props;
    const { Body, Content } = Styles;
    const project = {
        name: "Test Project",
        nameTheme: "wheat",
        members: "2 members",
        state:"Completed",
        stateTheme: "#009688",
        image: testImg,
        imageTheme: "red" ,
        teamTitle: "Project Members",
        teamTitleIcon : <i className="bi bi-people-fill"></i>,
        teamSection : [
            { name: "Paradox", icon: <i className="bi bi-bookmark-star-fill"></i>, theme: "wheat", link: null},
            { name: "Omicron", icon: <i className="bi bi-person-vcard-fill"></i>, theme: "purple", link: null},
            { name: "Crypto",  icon: <i className="bi bi-person-vcard-fill"></i>, theme: "purple", link: null},
            { name: "Crypto",  icon: <i className="bi bi-person-vcard-fill"></i>, theme: "purple", link: null},
        ],
        date: "2024/10/13",
        sections: [
            { title: "Title", text: "The sun rose slowly over the horizon, casting a warm golden light across the quiet town. Birds chirped cheerfully, filling the air with melodies as the first signs of life began to stir. A gentle breeze rustled the leaves of the trees, bringing with it the fresh scent of morning dew. It was a peaceful start to a new day, full of promise and possibility." },
            { title: "Title", text: "The sun rose slowly over the horizon, casting a warm golden light across the quiet town. Birds chirped cheerfully, filling the air with melodies as the first signs of life began to stir. A gentle breeze rustled the leaves of the trees, bringing with it the fresh scent of morning dew. It was a peaceful start to a new day, full of promise and possibility." },
            { title: "Title", text: "The sun rose slowly over the horizon, casting a warm golden light across the quiet town. Birds chirped cheerfully, filling the air with melodies as the first signs of life began to stir. A gentle breeze rustled the leaves of the trees, bringing with it the fresh scent of morning dew. It was a peaceful start to a new day, full of promise and possibility." },
        ],
        captionTheme: "gray",
        captionColor: "lightgray",
    };
    const headlines = [
        "Unveil the Future: Discover Our Groundbreaking Project!",
        "Join the Journey: Explore Our Innovative Project Today!",
        "Transform Ideas into Reality: Discover What We're Building!",
        "Dive into Creativity: Uncover Our Exciting Project Details!",
        "Collaboration at Its Best: Discover Our Team's Latest Project!",
        "Be Part of the Change: Explore Our Impactful Project!",
        "Innovate with Us: Discover the Vision Behind Our Project!",
        "Unlock New Possibilities: Learn About Our Ambitious Project!",
        "Your Invitation to Explore: Discover the Heart of Our Project!",
        "Experience Innovation: Dive into the Details of Our Project!"
    ];
    return (
        <main className={ Body }>
            <Navigator page={ "Projects" }/>
            <main className={ Content }>
                <ProHeadline headlines = { headlines }/>
                <Project     project   = { project   }/>
            </main>
        </main>
    );
};
